import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

const getCorporateUserOrgsFn = httpsCallable(functions, 'getCorporateUserOrgs');
const getCorporateDashboardFn = httpsCallable(functions, 'getCorporateDashboard');
const saveCorporateSessionAttendanceFn = httpsCallable(functions, 'saveCorporateSessionAttendance');
const exportCorporateDashboardReportFn = httpsCallable(functions, 'exportCorporateDashboardReport');
const addOrInviteCorporateMemberFn = httpsCallable(functions, 'addOrInviteCorporateMember');
const updateCorporateMemberFn = httpsCallable(functions, 'updateCorporateMember');
const changeCorporateMemberStatusFn = httpsCallable(functions, 'changeCorporateMemberStatus');
const acceptCorporateInviteFn = httpsCallable(functions, 'acceptCorporateInvite');

export async function fetchCorporateUserOrgs() {
  const result = await getCorporateUserOrgsFn();
  return result?.data?.memberships || [];
}

export async function fetchCorporateDashboard(orgId) {
  const result = await getCorporateDashboardFn({ orgId });
  return result?.data || null;
}

export async function saveSessionAttendance(orgId, session, attendance) {
  const result = await saveCorporateSessionAttendanceFn({ orgId, session, attendance });
  return result?.data || null;
}

export async function exportCorporateDashboardReport(params) {
  const result = await exportCorporateDashboardReportFn(params);
  return result?.data || null;
}

export async function addOrInviteCorporateMember(params) {
  const result = await addOrInviteCorporateMemberFn(params);
  return result?.data || null;
}

export async function updateCorporateMember(params) {
  const result = await updateCorporateMemberFn(params);
  return result?.data || null;
}

export async function changeCorporateMemberStatus(params) {
  const result = await changeCorporateMemberStatusFn(params);
  return result?.data || null;
}

export async function acceptCorporateInvite() {
  const result = await acceptCorporateInviteFn();
  return result?.data || null;
}
